import { authService } from "@/services"
import React from "react"
import {Navigate, Outlet} from "react-router-dom"

const useAuth = () => {
	try {
		const user = authService.getCurrentUser()
		const isAuthenticated = authService.isAuthenticated()
		
		if (user?.role && isAuthenticated) {
			return {
				auth: true,
				role: user.role,
			}
		} else {
			return {
				auth: false,
				role: null,
			}
		}
	} catch (error) {
		console.error('Error in useAuth:', error)
		// Clear potentially corrupted localStorage data
		localStorage.removeItem('user')
		localStorage.removeItem('access_token')
		return {
			auth: false,
			role: null,
		}
	}
}

//protected Route state
type ProtectedRouteType = {
	roleRequired?: string | string[]
};

const ProtectedRoutes = (props: ProtectedRouteType) => {
	const {auth, role} = useAuth()

	//if the role required is there or not
	if (props.roleRequired) {
		// Check if roleRequired is an array (multiple roles allowed)
		if (Array.isArray(props.roleRequired)) {
			return auth ? (
				props.roleRequired.includes(role) ? (
					<Outlet />
				) : (
					<Navigate to="/denied" />
				)
			) : (
				<Navigate to="/sign-in" />
			)
		} else {
			// Single role required
			return auth ? (
				props.roleRequired === role ? (
					<Outlet />
				) : (
					<Navigate to="/denied" />
				)
			) : (
				<Navigate to="/sign-in" />
			)
		}
	} else {
		return auth ? <Outlet /> : <Navigate to="/sign-in" />
	}
}

export default ProtectedRoutes
